import { render, staticRenderFns } from "./creatThird.vue?vue&type=template&id=76512b94&scoped=true"
import script from "./creatThird.vue?vue&type=script&lang=ts"
export * from "./creatThird.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76512b94",
  null
  
)

export default component.exports